import gql from "graphql-tag";

export const GET_MY_APPOINTMENTS = gql`
  query getMyAppointments($startRange: Date!, $endRange: Date!, $filter: JSON) {
    getMyAppointments(startRange: $startRange, endRange: $endRange, filter: $filter) {
      id
      allDay
      isFixed
      endDate
      startDate
      timeWindow {
        startTimeWindow
        endTimeWindow
      }
      subject
      technician {
        id
        firstName
        lastName
        market
        homePartsStore {
          id
          name
          vendor
        }
      }
      job {
        createdAt
        jobStartedAt
        zendeskTags
        id
        status
        jobName
        jobNumber
        serviceCatalogueUsed
        type
        vehicleInfo {
          make
          model
          year
        }
        items {
          name
          partsStore {
            id
            name
            vendor
            address
          }
        }
        partsInfo {
          partsLocation
          partsOrderNumber
          partsOrdered
          partsNotes
        }
        rescheduleSummary {
          total
        }
        partsStore {
          vendor
        }
        serviceLocation
        serviceLocationAddress {
          addressLine
          addressLine2
          city
          state
          zipCode
        }
        serviceLocationNotes
        description
        contact {
          id
          fullName
        }
      }
    }
  }
`;
